import BaseForm from '@js/forms/base-form'
import { DEFAULT_VALUES } from '@js/constants'

class FormSignup extends BaseForm {
  static getDataTemplate () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      emailVerificationCode: '',
      tenantInvitationCode: '',
      ssoCode: '',
    };
  }
  constructor () {
    super();
  }
  getPostPayload () {
    return {
      ...DEFAULT_VALUES.NEW_USER,
      firstName: this.data.firstName,
      lastName: this.data.lastName,
      email: this.data.email,
      password: this.data.password,
      verificationCode: this.data.emailVerificationCode,
      invitationCode: this.data.tenantInvitationCode,
      ssoCode: this.data.ssoCode,
    };
  }
}

export {
  FormSignup,
}
